import { createUninitializedContext } from '@crew/utils/context'

/** Context用の型 */
type GroupChatMemberListContext = {
  selectedUserIds: string[]
  setSelectedUserIds: (selectedUserIds: string[]) => void
}

/** Context */
const {
  context: groupChatMemberListContext,
  useInitializedContext: useGroupChatMemberListContext,
} = createUninitializedContext<GroupChatMemberListContext>()

export { useGroupChatMemberListContext }

export const useGroupChatMemberList = () => {
  return {
    groupChatMemberListContext,
  }
}
